import React, { useCallback, useState } from 'react'

import { DateTime } from 'luxon'

import CountDown from '@/CountDown'

import { num } from '@root/utility'

export default function WaitOpenPrivateSale ({ data, children })
{
	const [ended, setEnded] = useState(false);

	const NOW = DateTime.now();

	const open_time = DateTime.fromISO(data.opening.date).plus(
	{
		hours: num(data.opening.h),
		minutes: num(data.opening.m)
	});

	const endTimer = useCallback(function ()
	{
		setEnded(true);
	},
	[]);

	if (ended || open_time < NOW)
	{
		return children;
	}

	return (
		<div className="c-VP-waiter">

			<div className="c-VP-waiter__title">
				Ouverture de l'inscription dans
			</div>

			<CountDown start={ open_time } bemit={ ['VP-waiter'] }
				onEnded={ endTimer }
			/>

		</div>
	);
}